import { axiosInstance } from '../../config/axiosConfig';
//import { AxiosError, AxiosResponse } from 'axios';
import {
    DescriptiveTextInput,
    ICoreTaxesResponse,
    ICoreTaxesSummaryResponse,
    ICoreTaxVariationAssignmentInput,
    IDescriptiveTextbyIdResponse,
    IDescriptiveTextResponse,
    IInsuranceClassResponse,
    IInsuranceClassVariation,
    IInsuranceClassVariationPairsResponse,
    IJurisdictionsResponse,
    ISaveDescriptiveTextRequest,
    ISaveDescriptiveTextResponse,
    ISaveVariationResponse,
    ISaveVariationsRequest,
    IUpdateResponse,
    IVariationByCoreTaxParams,
    IVariationByCountryAndClassParams,
    IVariationInput,
    IVariationsResponse,
    VariationInput,
    ITaxNameResponse,
    ITaxNameCreateResponse,
    ITaxNameUpdateResponse,
    IDescriptiveTextCreateResponse,
    IVariationMappingReportResponse,
} from '../types/admin.type';
import { endPointUrls } from '../constants/endPoints';
import { AxiosError, AxiosResponse } from 'axios';

const getAdminInsuranceClasses = async ({
    pageSize = '10',
    pageNumber = '0',
    fieldName = 'insuranceClassId',
    sortOrder = 'desc',
}): Promise<IInsuranceClassResponse> => {
    try {
        const response = await axiosInstance.post(endPointUrls.getAdminInsuranceClasses, {
            pagination: {
                pageNumber,
                pageSize,
                fieldName,
                sortOrder,
            },
        });
        const data = await response.data;
        return data;
    } catch (error) {
        throw error;
    }
};

const getInsuranceClassVariationPairs = async ({
    pageSize = '10',
    pageNumber = '0',
    fieldName = 'insuranceClassId',
    sortOrder = 'ASC',
    searchString = '',
}): Promise<IInsuranceClassVariationPairsResponse> => {
    try {
        const response = await axiosInstance.post(endPointUrls.getInsuranceClassVariationPairs, {
            pagination: {
                pageNumber,
                pageSize,
                fieldName,
                sortOrder,
                searchString,
            },
        });
        const data = await response.data;
        return data;
    } catch (error) {
        throw error;
    }
};

const getJurisdictions = async ({
    pageSize = '10',
    pageNumber = '0',
    fieldName = 'jurisdictionId',
    sortOrder = 'ASC',
    searchString = '',
}): Promise<IJurisdictionsResponse> => {
    try {
        const response = await axiosInstance.post(endPointUrls.getJurisdictions, {
            pagination: {
                pageNumber,
                pageSize,
                fieldName,
                sortOrder,
                searchString,
            },
        });
        const data = await response.data;
        return data;
    } catch (error) {
        throw error;
    }
};

const getCoreTaxesSummary = async ({
    pageSize = '10',
    pageNumber = '0',
    fieldName = 'id',
    sortOrder = 'ASC',
    searchString = '',
}): Promise<ICoreTaxesSummaryResponse> => {
    try {
        const response = await axiosInstance.post(endPointUrls.getCoreTaxesSummary, {
            pagination: {
                pageNumber,
                pageSize,
                fieldName,
                sortOrder,
                searchString,
            },
        });
        const data = await response.data;
        return data;
    } catch (error) {
        throw error;
    }
};

const getAdminCoreTaxes = async ({
    pageSize = '10',
    pageNumber = '0',
    fieldName = 'id',
    sortOrder = 'ASC',
    searchString = '',
}): Promise<ICoreTaxesResponse> => {
    try {
        const response = await axiosInstance.post(endPointUrls.getAdminCoreTaxes, {
            pagination: {
                pageNumber,
                pageSize,
                fieldName,
                sortOrder,
                searchString,
            },
        });
        const data = await response.data;
        return data;
    } catch (error) {
        throw error;
    }
};

const getDescriptiveText = async ({
    pageSize = '10',
    pageNumber = '0',
    fieldName = 'descriptiveTextId',
    sortOrder = 'ASC',
    searchString = '',
}): Promise<IDescriptiveTextResponse> => {
    try {
        const response = await axiosInstance.post(endPointUrls.getAdminDescriptiveTexts, {
            pagination: {
                pageNumber,
                pageSize,
                fieldName,
                sortOrder,
                searchString,
            },
        });
        const data = await response.data;
        return data;
    } catch (error) {
        throw error;
    }
};

const getVariations = async ({
    pageSize = '10',
    pageNumber = '0',
    fieldName = 'descriptiveTextId',
    sortOrder = 'ASC',
    searchString = '',
}): Promise<IVariationsResponse> => {
    return axiosInstance
        .post(endPointUrls.getAdminVariations, {
            pagination: {
                pageNumber,
                pageSize,
                fieldName,
                sortOrder,
                searchString,
            },
        })
        .then((res: AxiosResponse<ISaveDescriptiveTextResponse>) => {
            const data = res.data;
            return data;
        })
        .catch((error) => {
            return error.response ? error.response.data.error : error;
        });
};

const saveAdminDescriptiveTexts = async ({
    descriptiveTexts,
}: {
    descriptiveTexts: DescriptiveTextInput[];
}): Promise<ISaveDescriptiveTextResponse> => {
    return axiosInstance
        .post(endPointUrls.postAdminDescriptiveTexts, descriptiveTexts)
        .then((res: AxiosResponse<ISaveDescriptiveTextResponse>) => {
            const data = res.data;
            return data;
        })
        .catch((error) => {
            return error.response ? error.response.data.error : error;
        });
};

const updateAdminDescriptiveTexts = async ({
    descriptiveTexts,
}: {
    descriptiveTexts: ISaveDescriptiveTextRequest[];
}): Promise<IUpdateResponse> => {
    return axiosInstance
        .patch(endPointUrls.postAdminDescriptiveTexts, descriptiveTexts)
        .then((res: AxiosResponse<IUpdateResponse>) => {
            const data = res.data;
            return data;
        })
        .catch((error) => {
            return error.response ? error.response.data.error : error;
        });
};

const saveAdminVariations = async ({
    variations,
}: {
    variations: VariationInput[];
}): Promise<ISaveVariationResponse> => {
    return axiosInstance
        .post(endPointUrls.postAdminVariations, variations)
        .then((res: AxiosResponse<ISaveVariationResponse>) => {
            const data = res.data;
            return data;
        })
        .catch((error) => {
            return error.response ? error.response.data.error : error;
        });
};

const updateAdminVariations = async ({
    variations,
}: {
    variations: ISaveVariationsRequest[];
}): Promise<IUpdateResponse> => {
    return axiosInstance
        .patch(endPointUrls.postAdminVariations, variations)
        .then((res: AxiosResponse<IUpdateResponse>) => {
            const data = res.data;
            return data;
        })
        .catch((error) => {
            return error.response ? error.response.data.error : error;
        });
};

const getDescriptiveTextById = (id: string): Promise<IDescriptiveTextbyIdResponse> => {
    return axiosInstance
        .get(endPointUrls.getAdminDescriptiveTextbyId + id)
        .then((res: AxiosResponse<IDescriptiveTextbyIdResponse>) => {
            return res.data;
        })
        .catch((error: AxiosError) => {
            throw error;
        });
};

const getVariationByCountryandInsuranceClass = async ({
    inputParameters,
}: { 
    inputParameters :IVariationByCountryAndClassParams;

}): Promise<IInsuranceClassVariation> => {
    return axiosInstance
        .post(endPointUrls.getVariationByCountryandInsuranceClass,inputParameters,
        )
        .then((res: AxiosResponse<IInsuranceClassVariation>) => {
            const data = res.data;
            return data;
        })
        .catch((error) => {
            return error.response ? error.response.data.error : error;
        });
};

const getVariationsByCoreTax = async ({
    inputParameters,
}: { 
    inputParameters :IVariationByCoreTaxParams;

}): Promise<IInsuranceClassVariation> => {
    return axiosInstance
        .post(endPointUrls.getVariationsByCoreTax,inputParameters,
        )
        .then((res: AxiosResponse<IInsuranceClassVariation>) => {
            const data = res.data;
            return data;
        })
        .catch((error) => {
            return error.response ? error.response.data.error : error;
        });
};

const assignVariationsToInsuranceClasses = async ({
    inputParameters,
}: { 
    inputParameters :IVariationInput[];

}): Promise<IUpdateResponse> => {
    return axiosInstance
        .post(endPointUrls.assignVariationsToInsuranceClasses,inputParameters,
        )
        .then((res: AxiosResponse<IUpdateResponse>) => {
            const data = res.data;
            return data;
        })
        .catch((error) => {
            return error.response ? error.response.data.error : error;
        });
};

const assignVariationsToCoreTax = async ({
    inputParameters,
}: { 
    inputParameters :ICoreTaxVariationAssignmentInput;

}): Promise<IUpdateResponse> => {
    return axiosInstance
        .post(endPointUrls.assignCoreTaxesToInsuranceClasses,inputParameters,
        )
        .then((res: AxiosResponse<IUpdateResponse>) => {
            const data = res.data;
            return data;
        })
        .catch((error) => {
            return error.response ? error.response.data.error : error;
        });
};

const getTaxNames = async ({
    pageSize = '10',
    pageNumber = '0',
    fieldName = 'taxName',
    sortOrder = 'asc',
}): Promise<ITaxNameResponse> => {
    try {
        const response = await axiosInstance.post(endPointUrls.getTaxNames, {
            pagination: {
                pageNumber,
                pageSize,
                fieldName,
                sortOrder,
            },
        });
        const data = await response.data;
        return data;
    } catch (error) {
        throw error;
    }
};

const createTaxName = async (taxNameDetails: any): Promise<ITaxNameCreateResponse> => {
    try {
        const response = await axiosInstance.post(endPointUrls.createTaxName, taxNameDetails);
        const data = await response.data;
        return data;
    } catch (error) {
        throw error;
    }
};

const updateTaxName = async (taxNameDetails: any): Promise<ITaxNameUpdateResponse> => {
    try {
        const response = await axiosInstance.patch(endPointUrls.updateTaxName, taxNameDetails);
        const data = await response.data;
        return data;
    } catch (error) {
        throw error;
    }
};

const createDescriptiveText = async (descriptiveTextDetails: any): Promise<IDescriptiveTextCreateResponse> => {
    try {
        const response = await axiosInstance.post(endPointUrls.createDescriptiveText, descriptiveTextDetails);
        const data = await response.data;
        return data;
    } catch (error) {
        throw error;
    }
};
const getUploadedVariationMappingReports = async ({
    pageSize = 10,
    pageNumber = 0,
    fieldName = 'uploadedDate',
    sortOrder = 'desc',
    searchString = '',
}): Promise<IVariationMappingReportResponse> => {
    try {
        const response = await axiosInstance.post(endPointUrls.getUploadedVariationMappings, {
            pagination: {
                pageNumber,
                pageSize,
                fieldName,
                sortOrder,
                searchString,
            },
        });
        const data = await response.data;
        return data;
    } catch (error) {
        throw error;
    }
};

const processVariationMappingFile = async (file: File): Promise<any> => {
    try {
        const formData = new FormData();
        formData.append('file', file);
        const response = await axiosInstance.post(endPointUrls.processVariationMappingFile, formData);
        const data = await response.data;
        return data;
    } catch (error) {
        throw error;
    }
};

const downloadVariationMappingErrorFile = async (uploadedFileId: string | number): Promise<any> => {
    try {
        const response = await axiosInstance.get(`${endPointUrls.downloadErrorFiles}/${encodeURIComponent(String(uploadedFileId))}`, {
            responseType: 'blob',
            headers: {
                Accept: 'application/octet-stream, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, text/csv, */*',
            },
        });
        const data = await response.data;
        return data;
    } catch (error) {
        throw error;
    }
};

const adminServices = {
    getAdminInsuranceClasses,
    getInsuranceClassVariationPairs,
    getCoreTaxesSummary,
    getAdminCoreTaxes,
    getDescriptiveText,
    getDescriptiveTextById,
    saveAdminDescriptiveTexts,
    updateAdminDescriptiveTexts,
    getVariations,
    saveAdminVariations,
    updateAdminVariations,
    getVariationByCountryandInsuranceClass,
    getVariationsByCoreTax,
    assignVariationsToInsuranceClasses,
    assignVariationsToCoreTax,
    getJurisdictions,
    getTaxNames,
    createTaxName,
    updateTaxName,
    createDescriptiveText,
    getUploadedVariationMappingReports,
    processVariationMappingFile,
    downloadVariationMappingErrorFile,
};

export default adminServices;
